import React, { useContext } from "react";
import { Modal, MobileContext } from "components/common";
import { Box } from "@material-ui/core";
import closeIcon from "assets/close.svg";
import BankAccountItem from "./BankAccountItem";

const BankAccountListModal = ({ accounts, isOpen, close }) => {
  const { isMobile } = useContext(MobileContext);

  const dynamicMaxHeight = isMobile ? "100vh" : "80vh";
  const dynamicMinHeight = isMobile ? "100vh" : "50vh";
  const dynamicMinWidth = isMobile ? "400px" : "450px";
  const dynamicItemsMaxHeight = isMobile ? "90vh" : "65vh";

  return (
    <Modal
      isOpen={isOpen}
      close={close}
      options={{ showCloseButton: false }}
    >
      <Box>
        <div
          style={{ maxHeight: dynamicMaxHeight, minHeight: dynamicMinHeight, minWidth: dynamicMinWidth }}
          className="bg-white rounded px-8 pt-6 whitespace-normal">
          <div className="flex justify-between items-center">
            <p className="text-2xl font-bold">Linked accounts</p>
            <button type="button" onClick={close}>
              <img src={closeIcon} alt="close"/>
            </button>
          </div>
          <div className="mt-4 pb-4 overflow-y-auto space-y-4" style={{ height: dynamicItemsMaxHeight }}>
            {accounts.map((a) => (
              <BankAccountItem account={a} key={a.uuid} />
            ))}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default BankAccountListModal;